import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  tabPanelContainer: {
    flex: 1,
  },
};

export default styles;
